/**
 * Was beim Start mit dem gesperrten Speicher geschehen soll.
 *
 * ## Warum das eine eigene Funktion ist
 *
 * Vier Eingänge, drei Ausgänge, und zwei Stellen in `App.tsx` müssen dieselbe
 * Antwort bekommen: der Effekt, der die Passkey-Zeremonie startet, und die
 * Ausgabe, die entweder wartet oder fragt. Standen die Bedingungen zweimal da,
 * ergab die kleinste Abweichung genau den Fehler, den Dan gemeldet hat: Es
 * entsperrt gleich — und einen Wimpernschlag lang blitzt trotzdem der
 * Frage-Bildschirm auf.
 *
 * Hier steht sie einmal, ohne Browser und ohne Krypto, und ist damit prüfbar.
 */

export type Autoversuch = 'offen' | 'laeuft' | 'fertig'

export type Entsperrschritt =
  /** Nichts anzeigen: Es läuft bereits etwas, das gleich entsperrt. */
  | 'warten'
  /** Die Passkey-Zeremonie ohne Zutun anstoßen. */
  | 'passkey-versuchen'
  /** Den Entsperr-Bildschirm zeigen. */
  | 'fragen'

export function entsperrschritt(lage: {
  /** Die Anmeldung hat gerade ein PRF-Geheimnis geliefert. */
  prfVorhanden: boolean
  /** Die Kontrolle alle vierzehn Tage ist fällig. */
  kontrolleFaellig: boolean
  /** Ist der Passkey für DIESEN Speicher hinterlegt? */
  passkeyEingerichtet: boolean
  autoVersuch: Autoversuch
}): Entsperrschritt {
  /*
   * Die Kontrolle geht allem vor — sonst wäre sie keine.
   *
   * Auch dem vorhandenen PRF-Geheimnis: Wer sich gerade mit dem Passkey
   * angemeldet hat, käme sonst an ihr vorbei, und die Abfrage käme nie.
   */
  if (lage.kontrolleFaellig) return 'fragen'

  // Der andere Effekt entsperrt damit still. Hier nichts anzeigen.
  if (lage.prfVorhanden) return 'warten'

  if (lage.autoVersuch === 'laeuft') return 'warten'

  /*
   * Ein Versuch je Start. Nach einem Abbruch NICHT noch einmal — sonst
   * schnappt die Zeremonie sofort wieder zu und niemand kommt an das
   * Eingabefeld darunter.
   */
  if (lage.autoVersuch === 'offen' && lage.passkeyEingerichtet) return 'passkey-versuchen'

  return 'fragen'
}
